import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'intDate' })
export class IntDatePipe implements PipeTransform {

    constructor( private datePipe: DatePipe ) {}

    public transform(value: any, args?: any): any {

        if (!value || typeof(value) !== 'string' || !value.match(/^[0-9]{8,8}$/)) return null;

        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6);

        return this.datePipe.transform(new Date( +year, +month - 1, +day), 'dd/MM/yyyy');

    }

}
